import script from "./FourthScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./FourthScreen.vue?vue&type=script&setup=true&lang=js"

import "./FourthScreen.vue?vue&type=style&index=0&id=0610ed3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0610ed3e"]])

export default __exports__